import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import appUtilitiesReducer, { initialState } from '../reducers/appUtilitiesReducer';

export const AppUtilitiesContext = createContext();

const AppUtilitiesProvider = ({ children }) => {
  const useAppUtilitiesState = useReducer(appUtilitiesReducer, initialState);

  return (
    <AppUtilitiesContext.Provider value={[...useAppUtilitiesState]}>
      <ContextDevTool
        context={AppUtilitiesContext}
        id="AppUtilitiesContext"
        displayName="AppUtilities Context"
      />
      {children}
    </AppUtilitiesContext.Provider>
  );
};

AppUtilitiesProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AppUtilitiesProvider;
